/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 50);
/******/ })
/************************************************************************/
/******/ ({

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51);


/***/ }),

/***/ 51:
/***/ (function(module, exports) {

$(function() {
    var after ='';
    var InterValObj; //timer变量，控制时间
    var count = 60; //间隔函数，1秒执行
    var curCount = 60;//当前剩余秒数
    var exp =new Date();
    var time;
    time = exp.getTime();

    //获取cookie值
    function getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
        return unescape(arr[2]);
        else
        return null;
    }

    //这是有设定过期时间的使用示例：
        //s20是代表20秒
        //h是指小时，如12小时则是：h12
        //d是天数，30天则：d30
    //设置cookie
    function setCookie(name,value,time){
        var strsec = getsec(time);
        var exp = new Date();
        exp.setTime(exp.getTime() + strsec*1);
        document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
    }

    function getsec(str){
        // alert(str);
        var str1=str.substring(1,str.length)*1;
        var str2=str.substring(0,1);
        if (str2=="s")
        {
            return str1*1000;
        }
        else if (str2=="h")
        {
            return str1*60*60*1000;
        }
        else if (str2=="d")
        {
            return str1*24*60*60*1000;
        }
    }

    $('#btnSendCode').click(function(e) {
        if(getCookie('after')>time &&  document.cookie.indexOf('after=') != -1){
            $('#timeshort').html('请不要在60秒内重复获取验证码');
        }else{
            $('#timeshort').html('');
        }
        trySend();//调用一次
    })

    $('#submit').click(function(e) {
        if(!validateForm()){
            return false;
        }

        var csrfToken = getCookie("csrfToken");

        $.ajax({
            url: "/api/commitForMobile",
            type: "post",
            dataType: "json",
            beforeSend: function(xhr) {
                xhr.setRequestHeader("x-csrf-token",csrfToken);
            },
            data: {
                "name": $('#name').val(),
                "school": $('#school').val(),
                "referee": $('#referee').val(),
                "email": $('#email').val(),
                "phone": $('#phone').val(),
                "identifyCode": $('#code').val()
            },
            success: function (data) {
                if (data.status) {
                    alert(data.message);
                } else {
                    alert(data.message);
                }
            },
            error: function () {
                alert("服务器连接错误");
            }
        });
    })

    function trySend() {
        if(getCookie('after')<time || document.cookie.indexOf('after=') == -1 || getCookie('after')==null){
            if(!validatePE($("#phone").val(),$("#email").val())){
                return false;
            }

            var csrfToken = getCookie("csrfToken");

            $.ajax({
                    url: "/api/sendIdentifyCode",
                    type: "post",
                    dataType: "json",
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("x-csrf-token", csrfToken )
                    },
                    data: {
                        "email": $('#email').val(),
                        "phone": $('#phone').val(),
                    },
                    success: function (data) {
                        if (data.status) {
                            alert(data.message);
                        } else {
                            alert(data.message);
                        }
                    },
                    error: function () {
                        alert("服务器连接错误");
                    }
                });

        setCookie("after",time+60*1000,"s60");
        setCookie("phone",$('#phone').val(),"s60");
        curCount = count;
        //设置button效果，开始计时
        $("#btnSendCode").attr("disabled", "true");
        $("#btnSendCode").val(curCount + "秒");
        InterValObj = window.setInterval(SetRemainTime, 1000); //启动计时器，1秒执行一次
        }
    }
    //timer处理函数
    function SetRemainTime() {
        if (curCount == 0) {
        window.clearInterval(InterValObj);//停止计时器
        $("#btnSendCode").removeAttr("disabled");//启用按钮
        $("#btnSendCode").val("重新发送");
        // code = ""; //清除验证码。如果不清除，过时间后，输入收到的验证码依然有效
    } else {
        curCount--;
        $("#btnSendCode").val(curCount + "秒");
        }
    }

    //modal弹层
    window.onload=function(){
        var share=document.getElementById('share');
        var modal=document.getElementById('modal');
        share.onclick=shield;
        modal.onclick=cancel_shield;

        function shield(e){
            e.preventDefault();
            var shade = document.getElementById("shade");
            shade.style.display = "block";

            var modal = document.getElementById("modal");
            modal.style.display = "block";
        }

        function cancel_shield(e){
            e.preventDefault();
            var shade = document.getElementById("shade");
            shade.style.display = "none";

            var modal = document.getElementById("modal");
            modal.style.display = "none";
        }
    };

    //验证手机号和邮箱
    function validatePE(phone, email) {
        var emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        var  telReg =  /(^1[3|4|5|7|8][0-9]{9}$)/;

        if(!email){

            alert("请填写您的邮箱地址");
            return false;

        }else if(email && !emailReg.test(email)) {

            alert("请填写正确的邮箱地址");
            return false;

        }
        if(!phone) {

            alert("请填写您的手机号码");
            return false;

        }else if(phone && !telReg.test(phone)) {

            alert("请填写正确的手机号码");
            return false;

        }
        return true;
    }

    //验证表单
    function validateForm () {

        if(!$("#name").val()) {

            alert("请填写您的姓名");
            return false;

        }else if(!$("#school").val()) {

            alert("请填写您的毕业院校");
            return false;

        }else if(!validatePE($("#phone").val(),$("#email").val())) {

            return false;

        }else if(!$("#code").val()) {

            alert("请填写验证码");
            return false;

        }
        return true;
    }
})


/***/ })

/******/ });


// WEBPACK FOOTER //
// join.js